module.exports = __webpack_public_path__ + "static/media/PRACTICA12.e5378cb9.jpg";